/* Cart page experience: robust discount-apply engine + Apply Coupon /
   Redeem Gift Card modals + per-item gift wrap + store-credit redemption +
   cart-total rewards hint.

   Discount apply: POST /cart/update.js with { discount: code } applies a
   code directly to the cart (no navigation to /discount/{code}), which is
   how offer-discovery's list AND the manual coupon input AND store-credit
   redemption all apply codes here - one fast, no-navigation path for all
   three. Shopify doesn't error on an invalid code, so success is detected
   by checking the returned cart's discount_codes array for our code with
   applicable: true. */
(function () {
  var STRINGS = window.cartExperienceStrings || {};

  function openDialog(backdrop, panel, closeBtn) {
    backdrop.setAttribute('aria-hidden', 'false');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var lastFocused = document.activeElement;
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 200);
    return lastFocused;
  }

  function closeDialog(backdrop, panel, lastFocused) {
    backdrop.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function trapFocus(panel, event) {
    if (event.key === 'Escape') return 'escape';
    if (event.key !== 'Tab') return;
    var focusables = panel.querySelectorAll('button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function updateCartPageSections() {
    if (!window.cartT4SectionID) return;
    fetch('/?section_id=' + window.cartT4SectionID)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-wrapper]');
        var current = document.querySelector('[data-cart-wrapper]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        // Any dialog that was open (offer-discovery drawer, gift-card
        // modal - both live inside this wrapper) just had its DOM node
        // replaced out from under it, so its own close() can never run to
        // undo the document.body.style.overflow = 'hidden' it set on open.
        // The fresh section markup always starts closed, so the page is
        // never legitimately scroll-locked at this point - clear it
        // unconditionally or the page is stuck unscrollable forever.
        document.body.style.overflow = '';
        // Store-credit and loyalty-earn-hint own elements live inside the
        // wrapper just replaced above, so their previous DOM nodes (and
        // any fetched-balance state) are gone - re-run against the fresh
        // ones. Modal triggers and gift-wrap checkboxes don't need this:
        // they're handled by document-level delegation above.
        initStoreCredit();
        if (window.T4SInitLoyaltyEarnHint) window.T4SInitLoyaltyEarnHint();
      })
      .catch(function () {});
  }

  // Listen for the theme-wide 'cart:refresh' event (already dispatched by
  // offer-discovery.js, sticky-mobile-atc.js, quick-order-list.js, and this
  // file's own refreshCartSections below) instead of only reacting to
  // direct function calls. Without this, anything that dispatches the
  // event but isn't inside this closure - offer-discovery's coupon apply
  // in particular - updates the mini-cart/header count (that listener
  // lives in interactable.min.js) but never the cart page's own price
  // details, which is exactly the "shows Applied but total doesn't move"
  // bug this fixes.
  document.addEventListener('cart:refresh', updateCartPageSections);

  function refreshCartSections() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* ---- Unified discount-apply engine --------------------------------- */
  // MINAKI Signal Layer bridge (additive, doesn't touch the apply logic
  // itself): this is the one real success/fail signal for a coupon apply
  // anywhere in the theme - offer-discovery's card, the cart page's own
  // form, both route through here. global-tracker.js listens for this
  // exact event name and relays it as form_submitted.
  function notifyMinakiFormResult(success, reason) {
    try {
      document.dispatchEvent(new CustomEvent('minaki:form-result', { detail: { form_type: 'coupon', success: success, reason: reason } }));
    } catch (e) { /* analytics bridge, never let it break the real apply flow */ }
  }

  function applyDiscountCode(code, callback) {
    if (!code) { callback && callback({ success: false, error: STRINGS.invalidCode }); notifyMinakiFormResult(false, 'missing_code'); return; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var match = codes.filter(function (dc) {
          return String(dc.code).toUpperCase() === String(code).toUpperCase();
        })[0];
        var success = !!(match && match.applicable);
        if (success) refreshCartSections();
        notifyMinakiFormResult(success, success ? undefined : (match ? 'not_applicable' : 'invalid_code'));
        callback && callback({ success: success, cart: cart });
      })
      .catch(function () {
        notifyMinakiFormResult(false, 'network_error');
        callback && callback({ success: false, error: STRINGS.networkError });
      });
  }

  window.T4SCartExperience = { applyDiscountCode: applyDiscountCode };

  /* ---- Redeem Gift Card modal (validate + preview only) ---------------- */
  function initGiftCardModal() {
    var panel = document.querySelector('[data-giftcard-modal-panel]');
    var backdrop = document.querySelector('[data-giftcard-modal-backdrop]');
    var closeBtn = document.querySelector('[data-giftcard-modal-close]');
    if (!panel || !backdrop) return;

    var lastFocused = null;
    var input = panel.querySelector('[data-giftcard-input]');
    var checkBtn = panel.querySelector('[data-giftcard-check]');
    var status = panel.querySelector('[data-giftcard-status]');
    var CODE_PATTERN = /^[A-Za-z0-9-]{8,20}$/;

    function open() { lastFocused = openDialog(backdrop, panel, closeBtn); }
    function close() { closeDialog(backdrop, panel, lastFocused); }

    // See initCouponModal - delegated because the trigger button lives
    // inside [data-cart-wrapper] and gets replaced by refreshCartSections().
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-giftcard-modal-open]')) open();
    });
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    panel.addEventListener('keydown', function (e) { if (trapFocus(panel, e) === 'escape') close(); });

    checkBtn.addEventListener('click', function () {
      var code = (input.value || '').trim();
      status.classList.remove('is--error', 'is--ok');
      if (!CODE_PATTERN.test(code)) {
        status.textContent = STRINGS.giftCardInvalidFormat || "That doesn't look like a valid gift card code.";
        status.classList.add('is--error');
        status.hidden = false;
        return;
      }
      status.textContent = STRINGS.giftCardReady || 'Ready — it will be applied at checkout.';
      status.classList.add('is--ok');
      status.hidden = false;
    });
  }

  /* ---- Per-item gift wrap ---------------------------------------------- */
  function initPerItemGiftWrap() {
    // Delegated on document - checkboxes live inside [data-cart-wrapper],
    // which refreshCartSections() replaces wholesale after every apply.
    // A direct per-checkbox listener would go dead after the first refresh.
    document.addEventListener('change', function (e) {
      var box = e.target.closest('[data-per-item-giftwrap]');
      if (!box) return;
      var variantId = box.dataset.giftVariantId;
      var itemKey = box.dataset.itemKey;
      box.disabled = true;
      if (box.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: { _gift_wrap_for: itemKey },
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (line) {
            box.dataset.giftWrapLineKey = line.key || '';
            box.disabled = false;
            refreshCartSections();
          })
          .catch(function () { box.checked = false; box.disabled = false; });
      } else {
        var lineKey = box.dataset.giftWrapLineKey;
        if (!lineKey) { box.disabled = false; return; }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        })
          .then(function () {
            box.disabled = false;
            delete box.dataset.giftWrapLineKey;
            refreshCartSections();
          })
          .catch(function () { box.disabled = false; });
      }
    });
  }

  /* ---- Store credit balance ---------------------------------------------
     Display-only: the loyalty_service.py backend credits real Shopify Store
     Credit directly to the customer's account (services/shopify/
     store_credit_service.py), which Shopify's own checkout applies
     automatically - there's no customer-initiated redeem step, so this just
     shows the live balance, not a toggle/button. */
  function initStoreCredit() {
    var el = document.querySelector('[data-store-credit]');
    if (!el) return;
    var textEl = el.querySelector('[data-store-credit-text]');
    var balanceEndpoint = el.dataset.balanceEndpoint;

    fetch(balanceEndpoint, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        el.hidden = false;
        if (!data || !data.success || !data.balance) {
          textEl.textContent = STRINGS.storeCreditNone || 'No Wallet Balance available yet.';
          return;
        }
        var template = STRINGS.storeCreditAvailable || 'You have <strong>₹{{ points }}</strong> in Wallet Balance';
        textEl.innerHTML = template.replace('{{ points }}', data.balance.toFixed(2));
      })
      .catch(function () {
        el.hidden = false;
        textEl.textContent = STRINGS.storeCreditNone || 'No Wallet Balance available yet.';
      });
  }

  /* ---- Shipping charges: India flat-Free, International = real rate ---- */
  function initShippingRateListener() {
    document.addEventListener('t4s:intl-rate-checked', function (event) {
      var row = document.querySelector('[data-shipping-charge-row]');
      var valueEl = document.querySelector('[data-shipping-charge-value]');
      var totalEl = document.querySelector('[data-er-cart-total-price]');
      if (!row || !valueEl || !totalEl) return;

      var rates = (event.detail && event.detail.rates) || [];
      var baseTotal = parseInt(row.dataset.baseTotal, 10) || 0;

      if (!rates.length) {
        valueEl.textContent = STRINGS.free || 'Free';
        totalEl.textContent = formatMoney(baseTotal);
        return;
      }
      var cheapest = rates.reduce(function (min, rate) {
        return parseFloat(rate.price) < parseFloat(min.price) ? rate : min;
      }, rates[0]);
      var cents = Math.round(parseFloat(cheapest.price) * 100);
      valueEl.textContent = formatMoney(cents);
      totalEl.textContent = formatMoney(baseTotal + cents);
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.T4SThemeSP) {
      try { return T4SThemeSP.Currency.formatMoney(cents); } catch (e) {}
    }
    return (cents / 100).toFixed(2);
  }

  /* ---- Order note: collapsed behind a click-to-expand toggle ----------- */
  function initOrderNoteToggle() {
    // Delegated - the toggle lives inside [data-cart-wrapper], which
    // refreshCartSections() replaces wholesale after every apply.
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-note-toggle]');
      if (!toggle) return;
      var body = toggle.parentElement.querySelector('[data-note-body]');
      if (!body) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
      if (!expanded) {
        var textarea = body.querySelector('textarea');
        if (textarea) textarea.focus();
      }
    });
  }

  function init() {
    initGiftCardModal();
    initPerItemGiftWrap();
    initStoreCredit();
    initShippingRateListener();
    initOrderNoteToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
